import React from 'react';
import { Modal, Typography } from 'antd';
import type { ModalProps } from 'antd';
import './AppDetailModal.css';

const { Text } = Typography;

interface AppDetailModalProps {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  status?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: number | string;
  className?: string;
  afterClose?: () => void;
  destroyOnClose?: boolean;
}

const AppDetailModal: React.FC<AppDetailModalProps> = ({
  open,
  onClose,
  title,
  subtitle,
  status,
  children,
  footer,
  width = 1040,
  className,
  afterClose,
  destroyOnClose = false,
}) => {
  const modalFooter: ModalProps['footer'] = footer === undefined
    ? null
    : <div className="app-detail-modal__footer">{footer}</div>;

  return (
    <Modal
      rootClassName="app-detail-modal-root"
      className={`app-detail-modal${className ? ` ${className}` : ''}`}
      title={(
        <div className="app-detail-modal__heading">
          <div className="app-detail-modal__title-row">
            <div className="app-detail-modal__title">{title}</div>
            {status ? <div className="app-detail-modal__status">{status}</div> : null}
          </div>
          {subtitle ? <Text type="secondary" className="app-detail-modal__subtitle">{subtitle}</Text> : null}
        </div>
      )}
      open={open}
      onCancel={onClose}
      width={width}
      centered
      footer={modalFooter}
      afterClose={afterClose}
      destroyOnHidden={destroyOnClose}
      styles={{ body: { padding: 0 } }}
    >
      <div className="app-detail-modal__body">{children}</div>
    </Modal>
  );
};

export default AppDetailModal;
